
import { fontSize, size } from '@styles/theme'
import { formatDistance } from 'date-fns'
import styled from '@emotion/styled'

import { GreyedTextStyles } from './DrawerLayout'
import { PiCalendarBlank } from 'react-icons/pi'

const renderFormattedTime = (datetime) => {
  let time = formatDistance(datetime, Date.now())
  time = time.replace('about ', '')
  return `${time} ago`
}

const JoinedContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: ${fontSize('xs')};
  ${GreyedTextStyles}
`

const DrawerJoinedText = ({ user, ...rest }) => {
  const renderText = () => {
    if (user?.isAnonymous) return (
      'Joined anonymously'
    )
    if (user?.registeredAt) return (
      <>
        <PiCalendarBlank fill='grey' size={size(1.5)} />
        &nbsp;Joined {renderFormattedTime(user?.registeredAt)}
      </>
    )
  }

  return (
    <JoinedContainer {...rest}>
      {renderText()}
    </JoinedContainer>
  )
}

export { DrawerJoinedText }
